(function () {
  function init() {
    var hs = document.querySelectorAll(".h1,.h2,.h3,.h4,.h5,.h6,p");
    var THIN_NBSP = "\u202F";
    var RE_SPACE_BEFORE_PUNCT = /[ \t]+(?=[;:?!»])/g;
    var RE_SPACE_AFTER_PUNCT = /«[ \t]+/g;

    for (var i = 0; i < hs.length; i++) {
      var el = hs[i];
      var html = el.innerHTML;

      html = html
        .replace(RE_SPACE_BEFORE_PUNCT, THIN_NBSP)
        .replace(RE_SPACE_AFTER_PUNCT, "«" + THIN_NBSP);

      el.innerHTML = html;
    }
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
